import { FETCH_ACCT_ITEMS_SUCCESS } from '../actions/item_actions';

export default function (state = {item_list: null}, action) {
    switch (action.type) {
    
      case FETCH_ACCT_ITEMS_SUCCESS:
        return {
          ...state, 
          item_list: action.payload.data.Data
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/reducers/item_list_reducer.js